if($('.id--16').length){
    $.getJSON('/user/documents/atypicka.json', function (data) {
        sessionStorage.setItem('atypickaData', JSON.stringify(data));
        checkOrderItems();
    });
    function checkOrderItems() {
        var atypickaData = JSON.parse(sessionStorage.getItem('atypickaData'));
        var found = false;

        // Porovnání .order-summary-item[data-micro-sku] s daty v sessionStorage
        $('.order-summary-item[data-micro-sku]').each(function () {
            var microSku = $(this).data('micro-sku');
            if (atypickaData.some(function (item) {
                return item.code == microSku;
            })) {
                found = true;
                return false; // přerušení each cyklu, pokud je nalezen
            }
        });

        if (!found) {
            // Procházení atypickaDoprava a aktualizace shipping metod
            atypickaDoprava.forEach(function (shippingId) {
                $('#order-shipping-methods #shipping-' + shippingId).hide();
            });
        }
    }
}

if($('.id--15').length){
    if($('[data-testid="recapPaymentMethod"]').text().trim() === 'Převodem'){
        $('.recapitulation-table-payment').hide()
        $('.recapitulation-table-payment').after('<div style="font-weight:700;text-align:left;color:rgb(207,0,0);">Při platbě převodem vyčkejte na zaslání zálohové faktury.</div>')

    }
}

var currentUrl = window.location.href;
if (!sessionStorage.getItem('initialReferrer')) {
    sessionStorage.setItem('initialReferrer', currentUrl);
}
if($('.id--17').length){
    $('.co-contact-information').append('<div class="form-group hide"><label for="text3">Referrer</label><input name="text3" type="text" value="" id="text3" class="form-control"></div>')
    var storageData = sessionStorage.getItem("initialReferrer");
    if (storageData) {
        $('input#text3').val(storageData)
    }
}

if($('.id--16').length){
    $(function() {
    var codes = [];
    $('.order-summary-item[data-micro-sku]').each(function() {
        var code = $(this).data('micro-sku');
        if (code) codes.push(code);
    });

    if (codes.length === 0) return;

    var apiUrl = 'https://tools.dostmedia.cz/ventila/api/api-dimension.php';

    $.ajax({
        url: apiUrl,
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({ codes: codes }),
        success: function(json) {
        if (!json.ok || !json.data) {
            console.warn('Chyba nebo prázdná data z API:', json);
            return;
        }
        var hasOversized = false;
        $.each(json.data, function(i, item) {
            var code = item.code;
            var height = item.height || '-';
            var depth = item.depth || '-';
            var width = item.width || '-';
            var $prod = $('.order-summary-item[data-micro-sku="' + code + '"]');
            if ($prod.length) {
           // var $dim = $('<div class="product-dimensions" style="font-size:12px; margin-top:3px;">Rozměry: ' 
           //     + height + ' × ' + depth + ' × ' + width + ' cm</div>');
            //$prod.append($dim);
            }
            if (Number(height) > size || Number(depth) > size || Number(width) > size) {
            hasOversized = true;
            }
        });
        if (hasOversized) {
            //var $msg = $('<div class="oversized-warning" style="background:#ffc107; color:#000; padding:10px; margin-bottom:10px; border-radius:6px;">⚠️ Některé produkty přesahují šířku 50&nbsp;cm – může být nutné speciální balení nebo doprava.</div>');
            $('#order-shipping-methods>div#shipping-17').addClass('haveSize').append('<div class="oversized-warning">'+sizeWarning+'</div>');
        }
        },
        error: function(xhr, status, error) {
        console.error('Chyba AJAX:', status, error);
        }
    });
    });

}